// extracted by mini-css-extract-plugin
export default {"letterI":"Background_letterI__jxOEV","letterT":"Background_letterT__b2Ojq","redHatch":"Background_redHatch__lMosZ","net":"Background_net__LFvU5"};